import spotify from '../../assets/spotify.jpeg';

import '../../styles/days.scss';

const Nine = () => (
  <div className='days full-image rounded'>
    <img src={spotify} alt='spotify wrapped' />
  </div>
);

export default Nine;
